<div id="add-benefit"  class="container-filter-cards">
  <div class="container-breadcrumb">
    <p id="id-breadcrumb-benefit" class="copec-lg-14">
      Beneficios / <span class="ruta">{{ isNew ? 'Crear Nuevo Beneficio' : 'Editar Beneficio'}}/</span>
    </p>
  </div>
  <div class="container-button-subtitle">
    <div class="box-button1">
      <span class="copec-bold-30">{{ isNew ? 'Crear Nuevo Beneficio' : 'Editar Beneficio'}}</span>
    </div>
  </div>
  <div class="espacio"></div>
</div>
<form>
  <mat-accordion id="cat-mat-1">
    <mat-expansion-panel id="cat-mat-2" [expanded]="isExpanded">
      <mat-expansion-panel-header id="cat-mat-3">
        <mat-panel-title id="cat-mat-4" class="copec-rg-20"
          >1.Información Básica</mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="box-description copec-lg-16">
        <span>Ingresa aquí la información básica. </span>
      </div>

      <div class="elementoInput">
        <label for="name-benefit" class="label-cat"
          ><h2 class="copec-rg-14">Nombre del Beneficio</h2>
        </label>
        <input
          type="text"
          class="text"
          placeholder="Nombre del Beneficio de hasta dos líneas de extensión"
          maxlength="70"
          [(ngModel)]="benefit.title"
          name="title"
          (ngModelChange)="countTitleCharacters()"

        />
        <span class="textfoot">{{ titleLength }}/70</span>
        <span *ngIf="errors.title" class="error-text">El nombre del beneficio es obligatorio.</span>
      </div>
      <div class="elementoInput">
        <label for="descent" class="label-cat"
          ><h2 class="copec-rg-14">Bajada</h2>
        </label>
        <input 
          type="text" 
          class="text" 
          placeholder="Bajada" 
          maxlength="80" 
          [(ngModel)]="benefit.description" 
          name="description"
          (ngModelChange)="descriptionCharacters()"

          />
        <span class="textfoot">{{descriptionLength}}/80</span>
        <span *ngIf="errors.description" class="error-text">La bajada es obligatoria.</span>
      </div>
      <div class="elementoInput">
        <label for="summary-benefit" class="label-cat"
          ><h2 class="copec-rg-14">Resumen</h2>
        </label>
        <input
          type="text"
          class="text"
          placeholder="Breve resumen orientativo del beneficio, de hasta 2 líneas de extensión"
          maxlength="180"
          [(ngModel)]="benefit.longDescription"
          name="longDescription"
          (ngModelChange)="countLongDescriptionCharacters()"
        />
        <span class="textfoot">{{ longDescriptionLength }}/180</span>
        <span *ngIf="errors.longDescription" class="error-text">El resumen es obligatorio.</span>
      </div>
      <div class="elementoInput_Resumen">
        <label for="summary-benefit" class="label-cat"
          ><h2 class="copec-rg-14">Beneficio aplica para:</h2>
        </label>
        <select class="copec-rg-14 style-input" [(ngModel)]="benefit.glosa" name="glosary" id="glosary">
          <option value="" selected="selected">.... Seleccione ....</option>
          <option value="Copec">Copec</option>
          <option value="Copec y Filiales">Copec y Filiales</option>
        </select>
        <span *ngIf="errors.glosa" class="error-text">Debe seleccionar para quién aplica el beneficio.</span>
      </div>
      <div class="elementoInput">
        <label class="label-cat" for="description-benefit"
          ><h2 class="copec-rg-14">Descripción del beneficio</h2>
        </label>
        <div style="background-color: white;">
        <angular-editor id="1" [(ngModel)]="htmlContent" name="htmlContent" [config]="config"></angular-editor>
        </div>
        <span *ngIf="errors.htmlContent" class="error-text">La descripción detallada es obligatoria.</span>
      </div>
      <div class="elementoInput">
        <label for="visual-documents" class="materialVisual">
          <h2 class="copec-bold-16">Material visual</h2>
        </label>

        <div class="container-loadImg">
          <p class="copec-bold-14 tituloImagen">Imagen</p>

          <div class="itemImg">
            <div
              class="boxImage"
              *ngIf="!benefit.image"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              <img src="/assets/icono/camera.svg" alt="" />
              <p>
                Arrastra la imagen que representará el beneficio o
                <a (click)="triggerFileInput()"><b>click aquí</b></a> para seleccionarla
                <input
                  #fileInput
                  type="file"
                  (change)="onFileChange($event)"
                  style="display: none;"
                />
              </p>
            </div>

            <div class="boxImage" *ngIf="benefit.image">
              <img [src]="benefit.image" alt="seleccionada" class="preview-img" />
            </div>

            <button
              *ngIf="benefit.image"
              (click)="removeImageBenefit()"
              class="remove-button"
            >
              X
            </button>
          </div>

          <span class="imgfoot">
            .PNG, .JPG, .JPEG. Dimensiones óptimas 668x396px. Máximo 500KB
          </span>

          <span *ngIf="errors.image" class="error-text">
            {{ errors.image === true ? 'Debe subir una imagen' : errors.image }}
          </span>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="espacio"></div>
  <mat-accordion id="cat-mat-5">
    <mat-expansion-panel id="cat-mat-6" [expanded]="isExpanded">
      <mat-expansion-panel-header id="cat-mat-7">
        <mat-panel-title id="cat-mat-8" class="copec-rg-20"
          >2.Tipo de Beneficio</mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="box-description copec-lg-16">
        <span>Ingresa aquí la información sobre el tipo de beneficio. </span>
      </div>
      <div class="elementoInput">
        <mat-radio-group
          class="example-radio-group"
          [(ngModel)]="selectOptionTypeBene"
          name="tipobenefit" 
          (change)="abrirLink()"
        >
          <mat-radio-button 
          class="example-radio-button" 
          value="BeneficioInfo"
          [checked]="selectOptionTypeBene === 'BeneficioInfo'"
          >
            Beneficio informativo
            <span class="radioletraploma"
              >(ej: Comunicación de beneficios que no requieren
              postulación)</span
            ></mat-radio-button
          >
          <mat-radio-button class="example-radio-button" value="BeneficioPost"
          [checked]="selectOptionTypeBene === 'BeneficioPost'" [disabled]="isNew">
            Beneficio con postulación
            <span class="radioletraploma">
              (ej: Beneficio que el trabajador debe solicitar llenando un
              formulario)</span
            ></mat-radio-button
          >
          <mat-radio-button class="example-radio-button" value="BeneficioLink"
          [checked]="selectOptionTypeBene === 'BeneficioLink'">
            Beneficio con link
            <span class="radioletraploma">
              (ej: Beneficio al que el trabajador accede a través de un sitio
              web externo)</span
            ></mat-radio-button
          >
        </mat-radio-group>
        <span *ngIf="errors.typeBene" class="error-text">Debe seleccionar un tipo de beneficio.</span>

        <section
          [ngClass]="{ 'benefit-link': !valid, 'benefit-linkShow': valid }"
        >
          <span class="copec-rg-14">Beneficio con Link</span><br />
          <span class="example-radio-button">URL</span>
          <input type="text" class="text" placeholder="URL" maxlength="2048"
           [(ngModel)]="benefit.link" name="link" [value]="benefit.link"/>
          <span *ngIf="errors.link" class="error-text">Debe ingresar una URL válida para el beneficio con link.</span>
        </section>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="espacio"></div>
  <mat-accordion id="cat-mat-9">
    <mat-expansion-panel id="cat-mat-10" [expanded]="isExpanded">
      <mat-expansion-panel-header id="cat-mat-11">
        <mat-panel-title id="cat-mat-12" class="copec-rg-20"
          >3.Información Complementaria</mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="box-description copec-lg-16">
        <span>Ingresa aquí la información complementaria. </span>
      </div>

      <div class="elementoInput">
        <label for="categories-benefits" class="label-cat"
          ><h2 class="subTitle-InfCom">Filiales</h2></label
        >
        <span class="lowTitle"
          >Elige las filiales asociadas a este beneficio</span
        >
        <section class="section-checkbox">
          <mat-checkbox *ngFor="let subsidiary of subsidiaries"
                  [checked]="benefit.subsidiaries.includes(subsidiary.filial_id)" 
                  (change)="subsidiarySelected($event, subsidiary.filial_id)">
          {{ subsidiary.nombre }}
          </mat-checkbox>
        </section>
        <span *ngIf="errors.subsidiaries" class="error-text">Debe seleccionar al menos una filial.</span>
      </div>

      <div class="elementoInput">
        <label for="categories-benefits" class="label-cat"
          ><h2 class="subTitle-InfCom">Categorías</h2></label
        >
        <span class="lowTitle"
          >Elige las categorias asociadas a este beneficio</span
        >
        <section class="section-checkbox">
          <mat-checkbox *ngFor="let category of optionCheckCategorias" 
                    [checked]="benefit.categories.includes(category.id)" 
                    (change)="categoriasSeleccionadas(category.id, $event)">
          {{ category.description  }}
          </mat-checkbox>
        </section>
        <span *ngIf="errors.categories" class="error-text">Debe seleccionar al menos una categoría.</span>
      </div>
      <div class="elementoInput">
        <label for="filters-benefits" class="label-cat"
          ><h2 class="subTitle-InfCom">Filtros</h2></label
        >
        <span class="lowTitle">Elige los filtros para este beneficio</span>
        <section class="section-checkbox1">
          <div class="item-checkbox1">
            <span class="titleColumn">Plan mínimo</span>
            <mat-checkbox *ngFor="let plan of plans"
            [checked]="benefit.plans.includes(plan.idplan)"
            (change)="planesSeleccionados(plan.idplan,$event)">{{plan.titleplan}}</mat-checkbox>
            <span *ngIf="errors.plans" class="error-text">Seleccione un plan.</span>
          </div>
          <div class="item-checkbox1">
            <span class="titleColumn">Antigüedad mínima</span>
            <mat-checkbox *ngFor="let ant of antiguedad" 
            [checked]="benefit.antiques.includes(ant.num)"   
            (change)="antiguedadSeleccionada(ant.num, $event)">{{ant.titulo}}</mat-checkbox>
            <span *ngIf="errors.antiques" class="error-text">Seleccione antigüedad.</span>
          </div>
          <div class="item-checkbox1">
            <span class="titleColumn">Beneficiarios</span>
            <mat-checkbox *ngFor="let type of beneficiaryTypes"
            [checked]="benefit.beneficiaryTypes.includes(type.id)"
            (change)="tipoSeleccionado($event, type.id)"
            > {{type.description}}</mat-checkbox>
            <span *ngIf="errors.beneficiaryTypes" class="error-text">Seleccione beneficiarios.</span>
          </div>
        </section>
      </div>
      <div class="elementoInput">
        <label for="tag-benefits" class="label-cat"
          ><h2 class="subTitle-InfCom">Etiqueta</h2></label
        >
        <span class="lowTitle"
          >Selecciona la etiqueta que se verá sobre la foto del beneficio</span
        >
        <section class="box-etiquetas">
          <button
           *ngFor="let etiq of buttonSelection"
            [ngClass]="{
              'etiq-info-Selected': etiq.id === benefit.textLabel.id,
              'etiqueta-infoCompl': etiq.id !== benefit.textLabel.id
            }"
            class=""
            (click)="selectButton(etiq.id)"
          >
            {{etiq.titulo}}
          </button>
        </section>
        <span *ngIf="errors.textLabel" class="error-text">Debe seleccionar una etiqueta.</span>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="espacio"></div>
  <mat-accordion id="cat-mat-13">
    <mat-expansion-panel id="cat-mat-14" [expanded]="isExpanded">
      <mat-expansion-panel-header id="cat-mat-15">
        <mat-panel-title id="cat-mat-16" class="copec-rg-20"
          >4.Publicación</mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="box-description copec-lg-16">
        <span>Agrega los parámetros de publicación </span>
      </div>
      <div class="elementoInput">
        <label for="publication-status" class="label-cat"
          ><h2 class="subTitle-InfCom">Estado de la publicación</h2></label
        >
        <mat-radio-group
          class="example-radio-group1"
          [(ngModel)]="estadoPublicacion"
          name="publicado"
          (change)="publicado()"
        >
          <mat-radio-button class="example-radio-button1" value="publicado" >
            Publicado
          </mat-radio-button>
          <mat-radio-button class="example-radio-button1" value="oculto" >
            Oculto
          </mat-radio-button>
          <mat-radio-button class="example-radio-button1" value="deshabilitado" >
            Deshabilitado
          </mat-radio-button>
        </mat-radio-group>
        <span *ngIf="errors.hidden" class="error-text">Debe seleccionar el estado de publicación.</span>
      </div>
      <div class="elementoInput" *ngIf="isNew">
        <span class="subTitle-InfCom">Programar publicación (opcional)</span>
        <section class="containerCalendar">
          <div class="item1">
            <span class="lowTitle1">Fecha de inicio</span>
            <mat-form-field>
              <mat-label for="start-date-benefits" class="copec-rg-14"
                >Día - Mes - Año</mat-label
              >
              <input matInput [matDatepicker]="dp"  [(ngModel)]="selectedStartDate" name="start-date-benefits"/>
              <mat-hint></mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="dp"
              >
                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="item2">
            <span class="lowTitle1">Hora de inicio</span>
            <mat-form-field>
              <mat-label for="start-time" class="copec-g-14">Hora</mat-label>
              <mat-select [(ngModel)]="selectedHourInicio" name="horario">
                <mat-option
                  class="copec-lg-14"
                  *ngFor="let hour of hours"
                  [value]="hour"
                >
                  {{ hour }}:00hrs
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="item3">
            <span class="lowTitle1">Fecha de finalización</span>
            <mat-form-field class="fondiis">
              <mat-label for="end-date-benefits" class="copec-rg-14"
                >Día - Mes - Año</mat-label
              >
              <input matInput [matDatepicker]="dp1" [(ngModel)]="selectedEndDate" name="end-date-benefits"/>
              <mat-hint></mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="dp1"
              >
                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #dp1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="item4">
            <span class="lowTitle1">Hora de finalización</span>
            <mat-form-field>
              <mat-label for="end-time-benefits" class="copec-rg-14"
                >Hora</mat-label
              >
              <mat-select [(ngModel)]="selectedHour" name="hora">
                <mat-option
                  class="copec-lg-14"
                  *ngFor="let hora of hours"
                  [value]="hora"
                >
                  {{ hora }}:00hrs
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="elementoInput">
    <div class="box-buttonPublish">
      <button type="button" class="publishBenefit" (click)="pushBenefit()">Publicar Beneficio</button>
    </div>
  </div>
</form>
